import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Custom fields.
 *
 * Perechile vechi: `settings/easeedesk/ticket_custom_fields`,
 * `get_custom_fields_list`, `edit_custom_field_form`, `create_custom_field`
 * (+ `create_custom_field_here`), `update_custom_field`, `delete_custom_field`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface CustomFieldType {
  value: string
  label: string
  /** Felurile care au de ales: `select`, `multiple_select`, `radio`. */
  options: boolean
}

export interface CustomFieldsShell {
  title: string
  moduleUrl: string
  types: CustomFieldType[]
}

export interface CustomField {
  ID: number
  field_type: string
  field_type_label: string
  field_name: string
  field_label: string
  field_info: string
  field_unique_id: string
  has_options: boolean
  options: string[]
}

export function customFieldsShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_custom_fields'],
    queryFn: () => apiGet<CustomFieldsShell>('/settings/easeedesk/ticket_custom_fields'),
  })
}

export function customFieldsListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_custom_fields', 'list'],
    queryFn: () => apiGet<{ fields: CustomField[] }>('/settings/easeedesk/ticket_custom_fields/list'),
  })
}

export function customFieldQuery(field: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_custom_fields', 'one', field],
    queryFn: () => apiGet<CustomField>(`/settings/easeedesk/ticket_custom_fields/${field}`),
    enabled: field > 0,
  })
}

export function createCustomField(
  field_type: string,
  field_name: string,
  field_label: string,
  field_info: string,
  options: string[],
) {
  return apiPost<{ ok?: boolean; field?: { ID: number; field_name: string; field_type: string; field_label: string } }>(
    '/settings/easeedesk/ticket_custom_fields',
    { field_type, field_name, field_label, field_info, 'field-options[]': options },
  )
}

export function updateCustomField(
  field: number,
  field_name: string,
  field_label: string,
  field_info: string,
  options: string[],
) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_custom_fields/${field}`, {
    field_name,
    field_label,
    field_info,
    'field-options[]': options,
  })
}

export function removeCustomField(field: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_custom_fields/${field}/remove`, {})
}
